module.exports = __webpack_public_path__ + "img/cloud2.d84bead7.png";